import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Text, useTheme } from '@Sage/hoi-poi-ui';

import './styles.scss';

const Step = memo(({ number, title, className, children }) => {
    const theme = useTheme();

    return (
        <div className={`step ${className || ''}`}>
            <div className="step__header">
                <div className="step__number">
                    <Text
                        type="subtitle"
                        bold
                        className="step__number-text"
                        color={theme.colors.grey[500]}
                    >
                        {number}
                    </Text>
                </div>
                <Text type="body" bold className="step__title">
                    {title}
                </Text>
            </div>
            <div className="step__content">{children}</div>
        </div>
    );
});

Step.propTypes = {
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
};

Step.displayName = 'Step';

export default Step;
